import { AppSession } from '@prisma/client'
import { Api } from '~/core/trpc'

type Props = {
  appSession: AppSession
}

export const useAbilities = ({ appSession }: Props) => {
  const formConfigurations = Api.formConfiguration.findMany.useQuery(
    {
      select: {
        id: true,
        title: true,
        description: true,
        key: true,
      },
      where: {
        appId: appSession?.appId,
        type: 'FLOW',
      },
    },
    { enabled: !!appSession, initialData: [] },
  )

  return {
    formConfigurations: formConfigurations.data,
  }
}
